<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KIr04H/tc-custom/9783988267467.jpg?1704453362430" alt="This image is the cover for the book Amazing Stories Volume 149, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Amazing Stories Volume 149, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Amazing Stories Volume 149 is a great collection of action short stories from "The Golden Age of Science Fiction". Featured here are three short stories by two different authors: "And The Gods Laughed" by Frederic Brown, "The Cosmic Express", and "The Pygmy Planet", both stories by Jack Williamson.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jack Williamson
      </h2>
      
      <p class="authorDescription body article">Jack Williamson was the working name of US author John Stewart Williamson (1908-2006), which he used from the beginning of his career in 1928, though his Seetee stories were originally signed Will Stewart. Williamson was born in Arizona and raised (after stints in Mexico and Texas) on an isolated New Mexico homestead, and spent his last decades as well in New Mexico; he described his early upbringing and his first encounter with sf in the 1920s in his introduction and notes to The Early Williamson (1975), which assembles some of the rough but vigorous stories he published 1928-1933; and amplified this autobiographical material in Wonder's Child: My Life in Science Fiction (1984), which won a 1985 Hugo. These reminiscences reconfirm the explosively liberating effect early Pulp-magazine sf had on its first young audiences, especially those who like Williamson grew up in small towns or farms across an America hurtling out of its rural past.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?41a4d626